import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { environment } from '../../../environments/environment';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { isVenueOpen, sleep, venueAcceptsOrders } from '../../../smoothr-web-app-core/utils/utils';
import Venue from '../../../smoothr-web-app-core/models/Venue';
import Address from '../../../smoothr-web-app-core/models/Address';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { MenuPage } from '../menu/menu.page';
import { HomePage } from '../home/home.page';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import { SelectLanguageModalComponent } from 'src/app/components/select-language-modal/select-language-modal.component';

enum Language {
	GreatBritain = 'en',
	German = 'de',
}

@Component({
	selector: 'app-select-venue',
	templateUrl: './select-venue.page.html',
	styleUrls: ['./select-venue.page.scss'],
})
export class SelectVenuePage extends RepositoryDirective implements OnInit {
	static url = 'select-venue';
	// static scanQr = 'scan-qr/:venueId/:tableId';
	environment = environment;
	languageEnum = Language;

	loading = false;
	preorderTypes = [PreorderType.TAKE_AWAY];
	active: any = {};
	loading$ = new BehaviorSubject(false);
	public relevantVenues: Venue[] = [];
	isVenueOpen = isVenueOpen;
	venueAcceptsOrders = venueAcceptsOrders;

	acceptsTakeaway = false;
	firstTakeAwayTime: string = null;

	constructor(
		protected repository: RepositoryService,
		public translate: TranslateService,
		private snackbarCtrl: MatSnackBar,
		private route: ActivatedRoute,
		private router: Router,
		private modalCtrl: ModalController
	) {
		super(repository);
		this.loading$.next(false);
	}

	static navigate(router: Router) {
		return router.navigateByUrl(SelectVenuePage.url);
	}

	ngOnInit() {
		super.ngOnInit();

		this.route.params.subscribe((params: any) => {
			if (params && params?.shortId) {
				this.loadSelectedVenue(params?.shortId);
			} else {
				this.locateAndShowStores(PreorderType.TAKE_AWAY);
			}
		});
	}
	async loadSelectedVenue(venueId: string) {
		try {
			console.log(venueId);

			this.loading$.next(true);
			// Load all venues instead of filtering to just one
			const venues = await this.repository.getAllVenues(environment.customerGroup);
			if (venues && venues.length > 0) {
				this.relevantVenues = venues;
				// Optionally mark the selected venue for UI highlighting
				// You can add a selectedVenueId property if needed
			}
			console.log(this.relevantVenues);
		} catch (error) {
			console.log('loadSelectedVenue has error!!!!');
			await this.locateAndShowStores(PreorderType.INSIDE);
		}
		this.loading$.next(false);
	}
	ionViewDidEnter() {
		if (history.state.navigationId === 1) {
			this.repository.onOrderChange(null);
		}
		this.repository.verifiedOrder.emit(null);
	}

	async locateAndShowStores(_preorderType: PreorderType) {
		this.loading$.next(true);
		const venues = await this.repository.getAllVenues(environment.customerGroup);
		if (venues.length > 0) {
			this.relevantVenues = venues;
		}
		this.loading$.next(false);
	}

	async loadVenueAndCreateOrder(venue: Venue, address: Address, preorderType: PreorderType) {
		const loadedVenue = await this.repository.getVenue(venue._id);
		this.repository.createOrder(loadedVenue, address, OrderType.PREORDER, preorderType);
		// await this.navigationService.menu();
		this.loading$.next(false);
	}

	loadVenues() {
		for (const preorderType of this.preorderTypes) {
			this.active[preorderType] = false;
		}
		new Promise<void>(async (resolve, reject) => {
			try {
				const venues = await this.repository.getAllVenues(environment.customerGroup);
				for (const venue of venues) {
					for (const preorderType of this.preorderTypes) {
						this.active[preorderType] = this.active[preorderType] || venueAcceptsOrders(venue, preorderType);
					}
				}
				resolve();
			} catch (e) {
				reject(e);
			}
		}).finally(() => this.loading$.next(false));
	}
	async goToMenu(type: PreorderType) {
		this.locateAndShowStores(type);
	}
	async goHome() {
		HomePage.navigate(this.router);
	}
	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
	}

	async selectLanguageModal() {
		await SelectLanguageModalComponent.show(this.modalCtrl);
	}
	goBack() {
		// this.navigationService.navigateToUrlWithParams(NAVIGATIONURLS.home(), null);
	}
	isVenueOpenFunc(venue: Venue) {
		if (this.isVenueOpen(venue)) {
			return this.translate.instant('venue_suggestion.open');
		}
		if (this.canPreorder(venue)) {
			return this.translate.instant('venue_suggestion.preorder_only');
		}
		return this.translate.instant('venue_suggestion.close');
	}

	canPreorder(venue: Venue): boolean {
		return this.preorderTypes.some(type => this.venueAcceptsOrders(venue, type));
	}

	canSelectVenue(venue: Venue, type: PreorderType): boolean {
		return this.isVenueOpen(venue) || this.venueAcceptsOrders(venue, type);
	}

	async openInfoPage(venue: Venue) {
		// TODO: Implement venue info modal
		console.log('Venue info:', venue);
	}

	accepts(type: PreorderType): boolean {
		switch (type) {
			case PreorderType.TAKE_AWAY:
				return this.acceptsTakeaway;
			default:
				return false;
		}
	}

	async selectVenue(venue: Venue, type: PreorderType) {
		this.loading$.next(true);
		const loadedVenue = await this.repository.getVenue(venue._id);
		console.log(loadedVenue);
		await sleep(100);
		if (!loadedVenue) {
			this.loading$.next(false);
			this.snackbarCtrl.open(this.translate.instant('home_page.venue_closed'), null, {
				duration: 5000,
			});
			return;
		}
		this.repository.createOrder(loadedVenue, null, OrderType.PREORDER, type);
		sleep(100);

		if (type === PreorderType.TAKE_AWAY) {
			this.loading$.next(false);
			await MenuPage.navigate(this.router);
		}
	}
}
